import { Integration } from 'signup-constants/Integration';
const DefaultIntegrationConfig = {
  shouldAskCompanyInfoOnLandingPage: false
};
const IntegrationConfigs = {
  [Integration.Wordpress]: Object.assign({}, DefaultIntegrationConfig, {
    name: Integration.Wordpress
  }),
  [Integration.Wpforms]: Object.assign({}, DefaultIntegrationConfig, {
    name: Integration.Wpforms
  }),
  [Integration.Shopify]: Object.assign({}, DefaultIntegrationConfig, {
    name: Integration.Shopify
  }),
  [Integration.Typeform]: Object.assign({}, DefaultIntegrationConfig, {
    name: Integration.Typeform
  })
};
export const getIntegrationConfig = integration => {
  return IntegrationConfigs[integration];
};